/**
 * @generated SignedSource<<f849c06fb87f0520b0d22cd0836aa48b>>
 * @relayHash a6b3ee34d3618ba11cfbaa4771f610ad
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db3c2d8c07b60231dc7ce1fca87ebd01cf8435eca67a123cc9b0d9fe1be40d66

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateMyLocaleInput = {
  clientMutationId?: string | null | undefined;
  locale: string;
};
export type I18nProviderUpdateLocaleMutation$variables = {
  input: UpdateMyLocaleInput;
};
export type I18nProviderUpdateLocaleMutation$data = {
  readonly updateMyLocale: {
    readonly user: {
      readonly id: string;
      readonly locale: string;
    } | null | undefined;
  } | null | undefined;
};
export type I18nProviderUpdateLocaleMutation = {
  response: I18nProviderUpdateLocaleMutation$data;
  variables: I18nProviderUpdateLocaleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateMyLocalePayload",
    "kind": "LinkedField",
    "name": "updateMyLocale",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "I18nProviderUpdateLocaleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "I18nProviderUpdateLocaleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "db3c2d8c07b60231dc7ce1fca87ebd01cf8435eca67a123cc9b0d9fe1be40d66",
    "metadata": {},
    "name": "I18nProviderUpdateLocaleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "62a25ae314ac0160df0cbf488966ec1a";

export default node;
